module.exports = __webpack_public_path__ + "img/sld_ch_10_t1_green.d0435a81.svg";